import React from "react";

function StoryPlay() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="37"
      height="37"
      viewBox="0 0 37 37"
    >
      <g id="Play_Icon" data-name="Play Icon" transform="translate(-1107 -134)">
        <circle
          id="Ellipse_327"
          data-name="Ellipse 327"
          cx="18.5"
          cy="18.5"
          r="18.5"
          transform="translate(1107 134)"
          opacity="0.5"
        />
        <path
          id="Path_24832"
          data-name="Path 24832"
          d="M19.376,12.416l-10.6,7.066A.5.5,0,0,1,8,19.066V4.934a.5.5,0,0,1,.777-.416l10.6,7.066a.5.5,0,0,1,0,.832Z"
          transform="translate(1112.516 140.5)"
          fill="#fff"
        />
      </g>
    </svg>
  );
}

export default StoryPlay;
